import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, { useEffect, useState } from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import { TApartment } from "types/dto";
import { netCall } from "utils/netCall";
import { ManagementApiUrl } from "environment/routeSettings";
import { toast } from "react-toastify";
import { TResponseCode } from "utils/netCall/types";
import { MapLocationPicker_v2 } from "components/MapLocationPicker_v2";
import { Controller } from "react-hook-form";
import { useRegion_v2 } from "contexts/regions_v2";
import { Permission } from "components/Permission";

type TProps = {
  apartmentId?: string;
  onChangeApartmentClick: () => void;
};
export const ApartmentsInfo = (props: TProps) => {
  const { apartmentId, onChangeApartmentClick } = props;
  const { allJurisdictions } = useRegion_v2();
  const [data, setData] = useState<TApartment>();
  const [isGettingData, setIsGettingData] = useState<boolean>(false);

  const getApartmentDetails = async (apartmentId: string) => {
    setIsGettingData(true);
    const res = await netCall<TApartment>({
      method: "GET",
      endPoint: `${ManagementApiUrl()}/api/Apartment/GetApartment/${apartmentId}`,
    });
    if (res.responseCode === TResponseCode.OK) {
      const record = res.results;
      setData(record);
    } else {
      toast.error(t("errorInGettingData"));
    }
    setIsGettingData(false);
  };

  useEffect(() => {
    if (apartmentId) {
      getApartmentDetails(apartmentId);
    }
  }, [apartmentId]);

  const { t } = useTranslation();
  return (
    <CollapsibleSection
      title={t("apartmentInfo")}
      collapsible={true}
      isLoading={isGettingData}
      skeleton="text"
    >
      <div className={"flex w-full gap-x-4"}>
        <div className={"flex flex-col w-3/5 gap-y-3"}>
          <TextValue
            title={t("identifierId")}
            value={data?.identifierId}
            className={"col-span-1"}
          />
          <TextValue
            title={t("numberOfFloor")}
            value={data?.numberOfFloor}
            className={"col-span-1"}
          />

          <TextValue
            title={t("latitude")}
            value={data?.latitude}
            className={"col-span-1"}
          />
          <TextValue
            title={t("longitude")}
            value={data?.longitude}
            className={"col-span-1"}
          />
          <TextValue
            title={t("address")}
            value={data?.address}
            className={"col-span-1"}
          />
          <TextValue
            title={t("id")}
            value={data?.id}
            className={"col-span-1"}
          />
          <TextValue
            title={t("province")}
            value={
              allJurisdictions?.find((item) => item.id === data?.jurisdictionId)
                ?.provinceName
            }
            className={"col-span-1"}
          />
          <TextValue
            title={t("city")}
            value={
              allJurisdictions?.find((item) => item.id === data?.jurisdictionId)
                ?.cityName
            }
            className={"col-span-1"}
          />
          <TextValue
            title={t("jurisdiction")}
            value={
              allJurisdictions?.find((item) => item.id === data?.jurisdictionId)
                ?.name
            }
            className={"col-span-1"}
          />
        </div>
        <div className={"flex w-2/5"}>
          {data?.latitude && data.longitude ? (
            <MapLocationPicker_v2
              className={"w-full h-[270px]"}
              onLocationPick={() => {}}
              initialMarker={{
                lat: data?.latitude,
                lng: data?.longitude,
              }}
            />
          ) : (
            <div className={"w-full h-full flex items-center justify-center"}>
              <p className={"text-sm text-gray-90 font-bold "}>
                {t("meterNotInstalled")}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex items-center justify-end mt-4">
        <Permission allowed={["superadmin", "d_watersubscriber"]}>
          <Button variant="outlined" onClick={onChangeApartmentClick}>
            {t("changeApartment")}
          </Button>
        </Permission>
      </div>
    </CollapsibleSection>
  );
};
